import { IAddressLookupState } from "./types";
import { ActionTree } from "vuex";
import { IRootState } from "@/store/types";
import api from "@/api/signup/api";
import { ADDRESS_LOOKUP } from ".";

export namespace ADDRESS_LOOKUP_ACTIONS {
  export const ADDRESS_LOOKUP_BY_KEY = "addressLookupByKey";
}

export const actions: ActionTree<IAddressLookupState, IRootState> = {
  async [ADDRESS_LOOKUP_ACTIONS.ADDRESS_LOOKUP_BY_KEY](
    { commit, dispatch, state },
    { key, address }
  ): Promise<void> {
    if (!address) {
      return;
    }

    try {
      commit(ADDRESS_LOOKUP.MUTATIONS.CHANGE_PROGRESS_BY_KEY, {
        key,
        type: "request"
      });

      const response = await api.searchAddresses(address);

      commit(ADDRESS_LOOKUP.MUTATIONS.CHANGE_PROGRESS_BY_KEY, {
        key,
        type: "success"
      });

      commit(ADDRESS_LOOKUP.MUTATIONS.SET_RESPONSE_BY_KEY, {
        data: response.data,
        key
      });
    } catch (error: any) {
      commit(ADDRESS_LOOKUP.MUTATIONS.CHANGE_PROGRESS_BY_KEY, {
        key,
        type: "error"
      });

      // Switch to manual input
      commit(ADDRESS_LOOKUP.MUTATIONS.SET_IS_MANUAL_BY_KEY, {
        isManual: true,
        key
      });
    }
  }
};
